import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Snackbar           from '@material-ui/core/Snackbar'
import { ReactComponent } from '../types'

const {
  Provider: AppToastControlProvider,
  Consumer: AppToastControlConsumer,
} = React.createContext({})

interface ToastControl {
  activate: () => void
  dismiss: () => void
  setMessage: (message: string) => void
}

interface State {
  isOpen: boolean
  message: string
}

interface AppToastProps {
  children: React.ReactNode
}

class AppToast extends React.Component<AppToastProps, State> {
  public state = {
    isOpen:  false,
    message: '',
  }

  public render () {
    const contextControls = this.getControls()

    return (
      <AppToastControlProvider value={contextControls}>
        {this.props.children}
        {this.renderToast()}
      </AppToastControlProvider>
    )
  }

  private renderToast = () => {
    const { isOpen, message } = this.state

    const toastMessage = <FormattedMessage id={message} />

    return (
      <Snackbar
        open={isOpen}
        message={toastMessage}
        autoHideDuration={4000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}

        onClose={this.dismiss}
      />
    )
  }

  private getControls = () => ({
    activate: this.activate,
    dismiss: this.dismiss,
    setMessage: this.setMessage,
  })

  private dismiss = () => {
    this.setState({ isOpen: false })
  }

  private activate = () => {
    this.setState({ isOpen: true })
  }

  private setMessage: ToastControl['setMessage'] = (message) =>
    this.setState({ message })
}

export default AppToast

export interface InjectedToastControl { toastControl: ToastControl }

type WithToastControl = <P> (Component: ReactComponent<P & InjectedToastControl>) => React.SFC<P>

export const withToastControls: WithToastControl = (Component) => {
  return function (props) {
    return (
      <AppToastControlConsumer>
        {(controls: ToastControl) => (
          <Component {...props} toastControl={controls} />
        )}
      </AppToastControlConsumer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/contexts/AppToast.tsx